export default __webpack_public_path__ + "static/media/g4.06590f45.png";